"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var clsx_1 = require("clsx");
var core_1 = require("@material-ui/core");
var ItemDetails_1 = require("../itemDetails/ItemDetails");
var ItemButton_1 = require("../button/ItemButton");
var itemStyles_1 = require("./itemStyles");
var Item = function (_a) {
    var _b;
    var item = _a.item, isSelected = _a.isSelected, handleSelectedItem = _a.handleSelectedItem;
    var styles = itemStyles_1.default();
    return (<core_1.Grid item xs={12} sm={6} lg={3} className={styles.itemWrapper} data-test={'checkout:extras:expression_of_interest:item'}>
      <core_1.Box className={clsx_1.default([
        styles.item,
        (_b = {},
            _b[styles.itemSelected] = isSelected,
            _b),
    ])} data-test={"checkout:extras:expression_of_interest:item:" + item.code}>
        <ItemDetails_1.default itemData={item.attributes}/>
        <ItemButton_1.default isSelected={isSelected} onClick={function () { return handleSelectedItem(item.code); }}/>
      </core_1.Box>
    </core_1.Grid>);
};
exports.default = Item;
